import { render, staticRenderFns } from "./dms-mps-name-add.vue?vue&type=template&id=0bdc7010&scoped=true"
import script from "./dms-mps-name-add.vue?vue&type=script&lang=js"
export * from "./dms-mps-name-add.vue?vue&type=script&lang=js"
import style0 from "./dms-mps-name-add.vue?vue&type=style&index=0&id=0bdc7010&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdc7010",
  null
  
)

export default component.exports